import { NotificationType, OrderDomainSpecificErrorCode } from '@vista/omnichannel-components-domain';
import { getIdForComponentNotification } from '../../../../utils/get-id-for-component-notification';
const getNotificationId = (context) => {
    return getIdForComponentNotification('ticket-redemption-code-form', NotificationType.Error, context);
};
export const getNotificationDetailsForError = (displayText, error) => {
    switch (error.errorCode) {
        case OrderDomainSpecificErrorCode.VoucherCredentialsInvalid:
            return {
                id: getNotificationId('voucher-credentials-invalid'),
                messages: [displayText.errorVoucherCredentialsInvalidMessage]
            };
        case OrderDomainSpecificErrorCode.ThirdPartyMemberCardDeclined:
            return {
                id: getNotificationId('third-party-member-card-declined'),
                messages: [displayText.errorThirdPartyMemberCardDeclinedMessage]
            };
        case OrderDomainSpecificErrorCode.ThirdPartyMemberCardAlreadyAdded:
            return {
                id: getNotificationId('third-party-member-card-already-added'),
                messages: [displayText.errorThirdPartyMemberCardAlreadyAddedMessage]
            };
        case OrderDomainSpecificErrorCode.VoucherAlreadyAdded:
            return {
                id: getNotificationId('voucher-already-added'),
                messages: [displayText.errorVoucherAlreadyAddedMessage]
            };
        case OrderDomainSpecificErrorCode.NoValidTicketsAvailableForThirdPartyMemberCard:
            return {
                id: getNotificationId('no-valid-tickets-available'),
                messages: [displayText.errorNoValidTicketsAvailableForThirdPartyMemberCardMessage]
            };
        default:
            return {
                id: getNotificationId('failed-to-add'),
                messages: [displayText.errorFailedToAddMessage]
            };
    }
};
